module.exports = __webpack_public_path__ + "img/pwa-role-select.45e76101.png";